import React from 'react';

interface TabData {
  id: string;
  tabTitle: string | React.ReactNode;
}

interface TabsProps {
  dataTabs: TabData[];
  setVisibleTab?: (id: string) => void;
  activeTab: string;
}

export const Tabs: React.FC<TabsProps> = ({ 
  dataTabs = [], 
  setVisibleTab, 
  activeTab 
}) => {
  return (
    <div className="mz-tabs">
      <div className="mz-tabs-menu">
        {
          dataTabs.map((item) =>
            <a
              onClick={() => setVisibleTab && setVisibleTab(item.id)}
              key={item.id}
              className={`mz-tabs-tab interactive ${activeTab === item.id ? 'active' : ''}`}
            >
              {item.tabTitle}
            </a>
          )
        }
      </div>
    </div>
  );
};

export default Tabs;
